import { useEffect, useState } from "react";
import { toast } from "sonner";
import { MapPin, Loader2 } from "lucide-react";
import { Switch } from "./ui/switch";
import { isAutoShare, sendLocation, startAutoShare, stopAutoShare } from "../lib/riderLocation";

const ERR = { denied: "رفضت إذن الموقع — فعّله من إعدادات المتصفح", unsupported: "جهازك لا يدعم تحديد الموقع", unavailable: "تعذّر تحديد موقعك — تأكد من تشغيل GPS", server: "تعذّر الإرسال" };

export const PortalLocationShare = () => {
  const [on, setOn] = useState(isAutoShare());
  const [busy, setBusy] = useState(false);
  useEffect(() => { if (isAutoShare()) startAutoShare(); }, []);
  const shareNow = async () => {
    setBusy(true);
    const r = await sendLocation("manual");
    setBusy(false);
    r.ok ? toast.success("تمت مشاركة موقعك") : toast.error(ERR[r.err] || "تعذّر الإرسال");
  };
  const toggle = async (v) => {
    if (v) {
      setBusy(true);
      const r = await sendLocation("manual");
      setBusy(false);
      if (!r.ok) { toast.error(ERR[r.err] || "تعذّر الإرسال"); return; }
      startAutoShare();
      toast.success("سيتم تحديث موقعك كل 5 دقائق أثناء فتح التطبيق");
    } else stopAutoShare();
    setOn(v);
  };
  return (
    <div className="mb-4 flex items-center gap-3 rounded-2xl border border-slate-200 bg-white p-4 shadow-sm" data-testid="portal-location-card">
      <div className="grid h-10 w-10 shrink-0 place-items-center rounded-xl bg-emerald-50 text-emerald-600"><MapPin className="h-5 w-5" /></div>
      <div className="min-w-0 flex-1">
        <p className="font-heading text-sm font-bold">مشاركة موقعي</p>
        <p className="text-[11px] text-slate-500">{on ? "مفعّل — يتحدّث كل 5 دقائق أثناء فتح التطبيق" : "شارك موقعك مع الإدارة"}</p>
      </div>
      <button onClick={shareNow} disabled={busy} className="rounded-full border border-slate-200 px-3 py-1.5 text-xs font-bold text-slate-700 hover:bg-slate-50" data-testid="portal-location-now">
        {busy ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : "الآن"}</button>
      <Switch checked={on} onCheckedChange={toggle} disabled={busy} data-testid="portal-location-auto" />
    </div>
  );
};
